import { useNavigate } from 'react-router-dom'

import { Plus } from 'lucide-react'

import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Button } from '@/common/ui/button'
import ChannelAnalyticTable from '../ChannelAnalyticTable'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { DataTableSelector } from '@/common/ui/table/data-table-selector'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { ChannelData } from '../../types'

interface ChannelAnalyticListingProps {
	data: ChannelData[]
	total: number
	isLoading?: boolean
}

const channelStatusOptions = [
	{ value: 'true', label: 'ใช้งาน' },
	{ value: 'false', label: 'ไม่มีการใช้งาน' },
]

export default function ChannelAnalyticListing({
	data,
	total,
	isLoading,
}: ChannelAnalyticListingProps) {
	const navigate = useNavigate()

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<div className="flex flex-col space-y-4">
					<Heading
						title={`ค่าเฉลี่ยตามแหล่งที่มา`}
						description="ค่าเฉลี่ยตามแหล่งที่มา"
					/>
					<div className="flex items-center gap-2">
						<DataTableSearch placeHolder="ค้นหาชื่อช่องทาง" />
						<DataTableSelector
							options={channelStatusOptions}
							placeholder="เลือกสถานะ"
							label="สถานะช่องทาง"
						/>
						<DataTableResetFilter />
					</div>
				</div>
				<div className="flex flex-col items-end gap-4">
					<div className="flex items-center gap-2">
						<Button
							onClick={() => navigate('/operator/get-channel')}
							className="flex items-center gap-2"
						>
							<Plus className="h-4 w-4" />
							จัดการช่องทาง
						</Button>
						<DateRangePicker />
					</div>
					<DateRangeButtons defaultValue="all" />
				</div>
			</div>

			<Separator />
			<ChannelAnalyticTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
